import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const parsePhoneNumber = (phoneNumber: string) => {
  const digits = phoneNumber?.replace(/\D/g, '')
  return digits?.startsWith('+') ? digits : `+${digits}`
}

export const formatDate = (date: string) => {
  const [day, month, year] = date.split('-').reverse()
  return `${day}.${month}.${year.slice(2)}`
}
